import { TrackingRegion } from '../../../common/AnalyticsContext/TrackingData';
import { ButtonVariants } from '../../../common/components/Button/DeprecatedButtonVariants';
import { StyledLinkButton } from '../../../common/components/Button/StyledButtons';
import { Heading } from '../../../common/components/Typography/Heading/Heading';
import { Kicker } from '../../../common/components/Typography/Heading/Heading.styles';
import { Paragraph } from '../../../common/components/Typography/Paragraph/Paragraph';
import { DisplayCard } from '../../../common/components/cards/DisplayCard/DisplayCard';
import { Row } from '../../../common/components/layout/FlexLayout';
import { PageSection } from '../../../common/components/layout/PageSection/PageSection';
import {
  MoreAboutHealthengineGraphic,
  MoreAboutHealthengineSectionCol,
} from './MoreAboutHealthengineSection.styles';

export const MoreAboutHealthengineEl = (
  <MoreAboutHealthengineGraphic
    src="/public/images/he-smiling-care_20210818090940.png"
    htmlAttributes={{ alt: 'Smiling Patient' }}
    imgixParams={{ fit: 'fill', ar: '16:9' }}
    sizes="100%"
  />
);

export const MoreAboutHealthEngineSection = () => (
  <PageSection trackingRegionId={TrackingRegion.ABOUT_HEALTHENGINE}>
    <DisplayCard imagePosition="left" imageElement={MoreAboutHealthengineEl}>
      <Row>
        <MoreAboutHealthengineSectionCol>
          <Kicker>More about Healthengine</Kicker>
          <Heading h3>
            Healthengine is the first place Australians go to navigate the complex world of
            healthcare.
          </Heading>
          <Paragraph>
            A clinically guided, online platform where patients get a better experience of finding,
            connecting and managing every step of their healthcare journey.
          </Paragraph>
          <StyledLinkButton
            to="https://about.healthengine.com.au/"
            variant={ButtonVariants.teal}
            options={{ keyline: true }}
          >
            Find out more
          </StyledLinkButton>
        </MoreAboutHealthengineSectionCol>
      </Row>
    </DisplayCard>
  </PageSection>
);
